import { useListUnreadModeratedStudyChats } from "~/api/generated/usabilityhub-components"

export const useUnreadChatNotifications = () => {
  // This query gets invalidated by the AccountChannel when it receives a
  // `moderated_study_chat_message.created` action.
  const {
    data: unreadChats,
    isLoading,
    isError,
  } = useListUnreadModeratedStudyChats({})

  if (isLoading || isError) return []

  return unreadChats
}
